import type { IStep } from '../context/StepsContext'

export const stepsVehicle: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    titleKey: 'wizard.vehicle.step1.title',
    path: '/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    titleKey: 'wizard.vehicle.step2.title',
    path: '/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    titleKey: 'wizard.vehicle.step3.title',
    path: '/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    titleKey: 'wizard.vehicle.step4.title',
    path: '/steps/4',
  },
]


export const stepsLeasing: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    titleKey: 'wizard.vehicle.step1.title',
    path: '/leasing/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    titleKey: 'wizard.vehicle.step2.title',
    path: '/leasing/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    titleKey: 'wizard.vehicle.step3.title',
    path: '/leasing/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    titleKey: 'wizard.vehicle.step4.title',
    path: '/leasing/steps/4',
  },
]

export const stepsFleet: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    titleKey: 'wizard.vehicle.step1.title',
    path: '/fleet/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    titleKey: 'wizard.vehicle.step2.title',
    path: '/fleet/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    titleKey: 'wizard.vehicle.step3.title',
    path: '/fleet/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    titleKey: 'wizard.vehicle.step4.title',
    path: '/fleet/steps/4',
  },
]

export const stepsVehicleExtra: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    titleKey: 'wizard.vehicle.step1.title',
    path: '/extra/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    titleKey: 'wizard.vehicle.step2.title',
    path: '/extra/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    titleKey: 'wizard.vehicle.step3.title',
    path: '/extra/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání smlouvy',
    titleKey: 'wizard.vehicle.step4.title',
    path: '/extra/steps/4',
  },
]

export const stepsTravel: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    titleKey: 'wizard.vehicle.step1.title',
    path: '/travel/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    titleKey: 'wizard.vehicle.step2.title',
    path: '/travel/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    titleKey: 'wizard.vehicle.step3.title',
    path: '/travel/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    titleKey: 'wizard.vehicle.step4.title',
    path: '/travel/steps/4',
  },
]


export const stepsProperty: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    titleKey: 'wizard.vehicle.step1.title',
    path: '/property/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    titleKey: 'wizard.vehicle.step2.title',
    path: '/property/steps/2',
  },
  {
    id: 3,
    title: 'Doplnění údajů',
    titleKey: 'wizard.property.step3.title',
    path: '/property/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    titleKey: 'wizard.vehicle.step4.title',
    path: '/property/steps/4',
  },
]

export const stepsPoleas: IStep[] = [
  {
    id: 1,
    title: 'Kontrola údajů',
    titleKey: 'wizard.poleas.step1.title',
    path: '/poleas/wizard/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    titleKey: 'wizard.vehicle.step2.title',
    path: '/poleas/wizard/2',
  },
  {
    id: 3,
    title: 'Doplnění údajů',
    titleKey: 'wizard.poleas.step3.title',
    path: '/poleas/wizard/3',
  },
  {
    id: 4,
    title: 'Sjednání',
    titleKey: 'wizard.poleas.step4.title',
    path: '/poleas/wizard/4',
  },
]
